import {
    Asset,
    ClosingCost,
    MortgageCalculation,
    MortgageCalculationResponse,
    PurchaseCost,
    RequiredAsset,
    SellingCost
} from '@ap/ap-interface-apix-hypotheken-berekening';

export class MortgageCalculationResponseBuilder {
    private mortgage: MortgageCalculation;
    private asset: Asset;
    private requiredAsset: RequiredAsset;
    private purchaseCost: PurchaseCost;
    private closingCost: ClosingCost;
    private sellingCost: SellingCost;

    withMortgage(mortgage: MortgageCalculation) {
        this.mortgage = mortgage;
        return this;
    }

    withAsset(asset: Asset) {
        this.asset = asset;
        return this;
    }

    withRequiredAsset(requiredAsset: RequiredAsset) {
        this.requiredAsset = requiredAsset;
        return this;
    }

    withPurchaseCost(purchaseCost: PurchaseCost) {
        this.purchaseCost = purchaseCost;
        return this;
    }

    withClosingCost(closingCost: ClosingCost) {
        this.closingCost = closingCost;
        return this;
    }

    withSellingCost(sellingCost: SellingCost) {
        this.sellingCost = sellingCost;
        return this;
    }

    build(): MortgageCalculationResponse {
        return {
            mortgage: this.mortgage,
            asset: this.asset,
            required_asset: this.requiredAsset,
            purchase_cost: this.purchaseCost,
            closing_cost: this.closingCost,
            selling_cost: this.sellingCost
        } as MortgageCalculationResponse;
    }
}
